import React from "react";

import CodeInput from "./CodeInput"

import Codes from "../common/Codes"
import Input from "./Input";

export default class Valuation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editable: props.editable,
            product: props.product,
            valuation: props.valuation
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps)
    }



    render() {
        let {
            editable,
            product,
            valuation,
        } = this.state

        let hidden = this.props.hidden
        let placeholder = this.props.placeholder

        return (
            <>
                <div className="row">
                    <div
                        className={`col ${this.props.fieldVisibilityClassName("Item Price (4/14)")}`}
                        hidden={hidden("valuation.amount")}
                    >
                        <div className="fv-row mb-3">
                            <Input
                              type="number"
                              value={valuation.amount}
                              placeholder={placeholder("valuation.amount", "Item Price (4/14)")}
                              onChange={amount => {
                                  valuation.amount = amount
                                  this.props.onUpdated(valuation)
                              }}
                              editable={editable && this.props.isEditableField("Item Price (4/14)")}
                              renderToolbar={() => this.props.renderToolbar("Item Price (4/14)", "Item Price (4/14)")}
                            />
                        </div>
                    </div>

                    <div
                        className={`col ${this.props.fieldVisibilityClassName("Statistical Value (8/6)")}`}
                        hidden={hidden("valuation.statistical")}
                    >
                        <div className="fv-row mb-3">
                            <Input
                              type="number"
                              value={valuation.statistical}
                              placeholder={placeholder("valuation.statistical", "Statistical Value (8/6)")}
                              editable={editable && this.props.isEditableField("Statistical Value (8/6)")}
                              renderToolbar={() => this.props.renderToolbar("Statistical Value (8/6)", "Statistical Value (8/6)")}
                              onChange={statistical => {
                                valuation.statistical = statistical
                                this.props.onUpdated(valuation)
                              }}
                            />
                        </div>
                    </div>

                    <div
                        className={`col-1 ${this.props.fieldVisibilityClassName("quantity")}`}
                        hidden={hidden("quantity")}
                    >
                        <div className="fv-row mb-3">
                            <Input
                              type="number"
                              value={product.quantity}
                              placeholder={placeholder("product.quantity", "Item Quantity")}
                              onChange={quantity => {
                                  product.quantity = quantity
                                  this.props.onQuantityUpdated(quantity)
                              }}
                              editable={editable && this.props.isEditableField("quantity")}
                              renderToolbar={() => this.props.renderToolbar("quantity", "Item Quantity")}
                            />
                        </div>
                    </div>

                    <div
                        className={`col ${this.props.fieldVisibilityClassName("Preference (4/17)")}`}
                        hidden={hidden("valuation.preference")}
                    >
                        <div className="fv-row mb-3">
                            <CodeInput
                              editable={editable && this.props.isEditableField("Preference (4/17)")}
                              listKey={"Preference"}
                              value={valuation.preference}
                              placeholder={placeholder("valuation.preference", "Preference (4/17)")}
                              onSelected={option => {
                                  valuation.preference = option
                                  this.props.onUpdated(valuation)
                              }}
                              renderToolbar={() => this.props.renderToolbar("Preference (4/17)", "Preference (4/17)")}
                            />
                        </div>
                    </div>

                    <div
                      className={`col ${this.props.fieldVisibilityClassName("Indicator (4/13)")}`}
                      hidden={hidden("valuation.indicator")}
                    >
                        <div className="fv-row mb-3">
                            <CodeInput
                              editable={editable && this.props.isEditableField("Indicator (4/13)")}
                              listKey={"ValuationIndicators"}
                              placeholder={placeholder("valuation.indicator", "Indicator (4/13)")}
                              value={valuation.indicator}
                              onSelected={option => {
                                  valuation.indicator = option
                                  this.props.onUpdated(valuation)
                              }}
                              renderToolbar={() => this.props.renderToolbar("Indicator (4/13)", "Indicator (4/13)")}
                            />
                        </div>
                    </div>
                    <div
                      className={`col ${this.props.fieldVisibilityClassName("Valuation Method (4/16)")}`}
                      hidden={hidden("valuation.method")}
                    >
                        <div className="fv-row mb-3">
                            <CodeInput
                              editable={editable && this.props.isEditableField("Valuation Method (4/16)")}
                              listKey={"ValuationMethod"}
                              placeholder={placeholder("valuation.method", "Valuation Method (4/16)")}
                              value={valuation.method}
                              onSelected={option => {
                                  valuation.method = option
                                  this.props.onUpdated(valuation)
                              }}
                              renderToolbar={() => this.props.renderToolbar("Valuation Method (4/16)", "Valuation Method (4/16)")}
                            />
                        </div>
                    </div>

                    <div
                        className={`col ${this.props.fieldVisibilityClassName("TransactionNature (8/5)")}`}
                        hidden={hidden("transaction_nature")}
                    >
                        <div className="fv-row mb-3">
                            <CodeInput
                              editable={editable && this.props.isEditableField("TransactionNature (8/5)")}
                              listKey={"NatureOfTransaction"}
                              placeholder={placeholder("valuation.transaction_nature", "Transaction Nature (8/5)")}
                              value={product.transaction_nature}
                              onSelected={option => {
                                  product.transaction_nature = option
                                  this.props.onTransactionNatureUpdated(option)
                              }}
                              renderToolbar={() => this.props.renderToolbar("TransactionNature (8/5)", "TransactionNature (8/5)")}
                            />
                        </div>
                    </div>
                </div>
              <div className={"row"}>

                <div
                  className={`col ${this.props.fieldVisibilityClassName("Currency")}`}
                  hidden={hidden("valuation.currency")}
                >
                  <div className="fv-row mb-3">
                    <CodeInput
                      editable={editable && this.props.isEditableField("Currency")}
                      listKey={"Currencies"}
                      placeholder={placeholder("valuation.currency", "Currency")}
                      value={valuation.currency}
                      onSelected={option => {
                        valuation.currency = option
                        this.props.onUpdated(valuation)
                      }}
                      renderToolbar={() => this.props.renderToolbar("Currency", "Currency")}
                    />
                  </div>
                </div>

                <div
                  className={`col ${this.props.fieldVisibilityClassName("Transport & Insurance Costs to Destination Amount")}`}
                  hidden={hidden("valuation.destination_transport_amount")}
                >
                  <div className="fv-row mb-3">
                    <Input
                      type="number"
                      value={valuation.destination_transport_amount}
                      placeholder={placeholder("valuation.destination_transport_amount", "Transport & Insurance Costs to Destination Amount")}
                      onChange={destinationTransportAmount => {
                        valuation.destination_transport_amount = destinationTransportAmount
                        this.props.onUpdated(valuation)
                      }}
                      editable={editable && this.props.isEditableField("destination_transport_amount")}
                      renderToolbar={() => this.props.renderToolbar("destination_transport_amount", "Transport & Insurance Costs to Destination Amount")}
                    />
                  </div>
                </div>

                <div
                  className={`col ${this.props.fieldVisibilityClassName("Transport & Insurance Costs to Destination Currency")}`}
                  hidden={hidden("valuation.destination_transport_currency")}
                >
                  <div className="fv-row mb-3">
                    <CodeInput
                      editable={editable && this.props.isEditableField("destination_transport_amount")}
                      listKey={"Currencies"}
                      placeholder={placeholder("valuation.destination_transport_currency", "Transport & Insurance Costs to Destination Currency")}
                      value={valuation.destination_transport_currency}
                      onSelected={option => {
                        valuation.destination_transport_currency = option
                        this.props.onUpdated(valuation)
                      }}
                      renderToolbar={() => this.props.renderToolbar("Transport & Insurance Costs to Destination Currency", "Transport & Insurance Costs to Destination Currency")}
                    />
                  </div>
                </div>
              </div>
            </>
        )
    }


}

Valuation.defaultProps = {}
